<div class="tpl3pl-page-container">
	<mat-tab-group animationDuration="0" (selectedIndexChange)="onTabChange($event)">

		<!-- ── Tab 0: Activity (inbound log) ── -->
		<mat-tab>
			<ng-template mat-tab-label>
				<span>Activity</span>
				<span *ngIf="activityFilterStatus === 'error' && activityRows.length > 0" class="tab-badge tab-badge-danger ml-1">{{ activityRows.length }}</span>
			</ng-template>
			<div class="tab-content">

				<div class="d-flex align-items-center mb-3 flex-wrap" style="gap:8px">
					<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:140px">
						<mat-label>Status</mat-label>
						<mat-select [(ngModel)]="activityFilterStatus" (selectionChange)="loadActivity()">
							<mat-option value="">All</mat-option>
							<mat-option value="success">Success</mat-option>
							<mat-option value="error">Error</mat-option>
							<mat-option value="warning">Warning</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:160px">
						<mat-label>From</mat-label>
						<input matInput type="date" [(ngModel)]="activityFilterFromDate" (change)="loadActivity()">
					</mat-form-field>
					<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:160px">
						<mat-label>To</mat-label>
						<input matInput type="date" [(ngModel)]="activityFilterToDate" (change)="loadActivity()">
					</mat-form-field>
					<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:180px">
						<mat-label>PO #</mat-label>
						<input matInput [(ngModel)]="activityFilterPo" (keyup.enter)="loadActivity()" placeholder="Optional">
					</mat-form-field>
					<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:110px">
						<mat-label>Limit</mat-label>
						<mat-select [(ngModel)]="activityLimit" (selectionChange)="loadActivity()">
							<mat-option [value]="50">50</mat-option>
							<mat-option [value]="100">100</mat-option>
							<mat-option [value]="250">250</mat-option>
							<mat-option [value]="500">500</mat-option>
						</mat-select>
					</mat-form-field>
					<button mat-stroked-button (click)="loadActivity()" [disabled]="activityLoading">
						<mat-spinner *ngIf="activityLoading" diameter="18"></mat-spinner>
						<mat-icon *ngIf="!activityLoading">refresh</mat-icon>
						Refresh
					</button>
					<button mat-stroked-button (click)="resetActivityFilters()" matTooltip="Reset to last 30 days, errors only">
						<mat-icon>clear</mat-icon>
						Reset
					</button>
					<span class="text-muted small ml-auto" *ngIf="activityTotal > 0">
						Showing {{ activityRows.length }} of {{ activityTotal }} total
					</span>
				</div>

				<div *ngIf="activityError" class="alert alert-warning py-2 small">{{ activityError }}</div>
				<div *ngIf="activityLoading && activityRows.length === 0" class="text-muted small">Loading…</div>
				<div *ngIf="!activityLoading && activityRows.length === 0 && !activityError" class="alert alert-success py-2 small">
					No inbound activity matches these filters.
				</div>

				<table *ngIf="activityRows.length > 0" class="table table-sm table-hover">
					<thead>
						<tr>
							<th>When</th>
							<th>Status</th>
							<th>PO#</th>
							<th>Message</th>
							<th class="text-nowrap"></th>
						</tr>
					</thead>
					<ng-container *ngFor="let e of activityRows">
						<tr>
							<td class="text-nowrap text-muted small">{{ e.created_at | date:'M/d/yy, h:mm a' }}</td>
							<td class="text-nowrap">
								<span class="badge" [ngClass]="{
									'badge-success': e.status === 'success',
									'badge-danger': e.status === 'error',
									'badge-warning': e.status === 'warning'
								}">{{ e.status }}</span>
							</td>
							<td class="font-weight-bold small">{{ e.orderno || '—' }}</td>
							<td class="small" [ngClass]="{'text-danger': e.status === 'error'}" style="max-width:34rem;word-break:break-word;">{{ e.message }}</td>
							<td class="text-nowrap">
								<button *ngIf="e.status === 'error' && e.orderno && isSkuError(e.message)"
									mat-icon-button
									[color]="skuCheckPo === e.orderno ? 'accent' : ''"
									(click)="toggleSkuCheck(e.orderno)"
									matTooltip="Check SKU mapping status">
									<mat-icon>search</mat-icon>
								</button>
								<button *ngIf="e.status === 'error' && e.orderno" mat-stroked-button color="primary" class="btn-sm" (click)="openResendPreview(e.orderno)" matTooltip="Preview payload &amp; resend">
									<mat-icon>preview</mat-icon>
									Preview &amp; Resend
								</button>
								<button mat-icon-button (click)="openInboundAttemptRaw(e)" matTooltip="View raw">
									<mat-icon>code</mat-icon>
								</button>
							</td>
						</tr>
						<!-- SKU mapping breakdown panel -->
						<tr *ngIf="skuCheckPo === e.orderno">
							<td colspan="5" class="p-0">
								<div class="px-3 py-2" style="background:#f8f9fa;border-left:3px solid #dc3545">
									<div *ngIf="skuCheckLoading" class="text-muted small py-2">Checking SKU mapping status…</div>
									<div *ngIf="skuCheckError" class="text-danger small py-2">{{ skuCheckError }}</div>
									<ng-container *ngIf="skuCheckData">
										<div class="d-flex align-items-center mb-2" style="gap:12px">
											<strong class="small">SKU Status — PO {{ skuCheckData.orderno }}</strong>
											<span class="badge badge-secondary">{{ skuCheckData.total_sent }} sent</span>
											<span class="badge badge-danger">{{ skuCheckData.flagged_count - skuCheckData.resolved_count }} still missing from 3PL</span>
											<span *ngIf="skuCheckData.resolved_count > 0" class="badge badge-success">{{ skuCheckData.resolved_count }} now in 3PL</span>
										</div>
										<table class="table table-xs table-bordered mb-0" style="font-size:0.78rem">
											<thead>
												<tr>
													<th>SKU</th>
													<th>Description</th>
													<th class="text-center">In ERP</th>
													<th class="text-center">Pushed to 3PL</th>
													<th>Notes</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let s of skuCheckData.skus"
													[ngClass]="{
														'table-danger': s.flagged && !s.in_3pl,
														'table-success': s.resolved,
														'table-warning': s.flagged && !s.in_erp
													}">
													<td class="font-weight-bold font-monospace">{{ s.sku }}</td>
													<td class="small">{{ s.description || '—' }}</td>
													<td class="text-center">
														<mat-icon style="font-size:16px;line-height:16px" [ngClass]="s.in_erp ? 'text-success' : 'text-danger'">
															{{ s.in_erp ? 'check_circle' : 'cancel' }}
														</mat-icon>
													</td>
													<td class="text-center">
														<mat-icon style="font-size:16px;line-height:16px" [ngClass]="s.in_3pl ? 'text-success' : 'text-danger'">
															{{ s.in_3pl ? 'check_circle' : 'cancel' }}
														</mat-icon>
													</td>
													<td class="small text-muted">
														<span *ngIf="!s.in_erp" class="text-danger">Not in ERP — deleted?</span>
														<span *ngIf="s.in_erp && s.discontinued" class="text-warning">Discontinued</span>
														<span *ngIf="s.in_erp && !s.in_3pl && s.flagged" class="text-danger">Needs SKU push to 3PL</span>
														<span *ngIf="s.resolved" class="text-success">Now in 3PL — retry PO</span>
														<span *ngIf="!s.flagged && s.in_3pl">OK</span>
													</td>
												</tr>
											</tbody>
										</table>
									</ng-container>
								</div>
							</td>
						</tr>
					</ng-container>
				</table>

			</div>
		</mat-tab>

		<!-- ── Tab 1: Inbound Sends (every PO we've sent inbound for) ── -->
		<mat-tab label="Inbound Sends">
			<div class="tab-content">
				<div class="mb-3 p-3" style="background:#f4f6fa;border-radius:4px;border-left:3px solid #1976d2">
					<p class="text-muted small mb-2 mb-md-1">Send or resend an inbound for a specific PO (including POs that were never sent to PGS).</p>
					<div class="d-flex align-items-center flex-wrap" style="gap:8px">
						<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:180px">
							<mat-label>PO number</mat-label>
							<input matInput [(ngModel)]="statusLookupPo" (keyup.enter)="openResendPreview(statusLookupPo, false)" placeholder="e.g. 203858">
						</mat-form-field>
						<button mat-stroked-button color="primary" (click)="openResendPreview(statusLookupPo, false)" [disabled]="!(statusLookupPo || '').trim()">
							<mat-icon>preview</mat-icon>
							Preview &amp; Send
						</button>
						<button mat-raised-button color="accent" (click)="submitUnsentPo()" [disabled]="submitUnsentLoading || !(statusLookupPo || '').trim()">
							<mat-spinner *ngIf="submitUnsentLoading" diameter="18"></mat-spinner>
							<mat-icon *ngIf="!submitUnsentLoading">send</mat-icon>
							{{ submitUnsentLoading ? 'Sending…' : 'Send now' }}
						</button>
						<button mat-stroked-button (click)="lookupInboundStatusByPo()" [disabled]="statusLookupLoading || !(statusLookupPo || '').trim()">
							<mat-icon>info</mat-icon>
							Status
						</button>
					</div>
					<div *ngIf="statusLookupLoading" class="text-muted small mt-2">Loading status…</div>
					<div *ngIf="inboundPoError" class="alert alert-warning py-2 small mt-2 mb-0">{{ inboundPoError }}</div>
					<div *ngIf="inboundPoStatus && !statusLookupLoading" class="small mt-2">
						<span class="badge" [ngClass]="inboundPoStatus.sent ? 'badge-success' : 'badge-secondary'">
							{{ inboundPoStatus.sent ? 'Sent to 3PL' : 'Not sent to 3PL' }}
						</span>
						<span *ngIf="inboundPoStatus.attempt_count" class="text-muted ml-2">{{ inboundPoStatus.attempt_count }} attempt(s)</span>
						<span *ngIf="inboundPoStatus.pgsInboundID" class="text-muted ml-2">PGS ID: {{ inboundPoStatus.pgsInboundID }}</span>
					</div>
				</div>
				<div class="d-flex align-items-center mb-3 flex-wrap" style="gap:8px">
					<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:160px">
						<mat-label>Status</mat-label>
						<mat-select [(ngModel)]="erpReceiptsFilterStatus" (selectionChange)="loadErpReceipts()">
							<mat-option value="">All</mat-option>
							<mat-option value="sent">Sent (last attempt OK)</mat-option>
							<mat-option value="errored">Errored (last attempt failed)</mat-option>
							<mat-option value="received">Has receipts from PGS</mat-option>
							<mat-option value="unreceived">Sent · no receipts yet</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field appearance="outline" class="tpl3pl-field mb-0">
						<mat-label>Filter by PO</mat-label>
						<input matInput [(ngModel)]="erpReceiptsFilterPo" (keyup.enter)="loadErpReceipts()" placeholder="Leave blank for all">
					</mat-form-field>
					<mat-form-field appearance="outline" class="tpl3pl-field mb-0" style="width:110px">
						<mat-label>Limit</mat-label>
						<mat-select [(ngModel)]="erpReceiptsLimit" (selectionChange)="loadErpReceipts()">
							<mat-option [value]="50">50</mat-option>
							<mat-option [value]="100">100</mat-option>
							<mat-option [value]="250">250</mat-option>
							<mat-option [value]="500">500</mat-option>
						</mat-select>
					</mat-form-field>
					<button mat-stroked-button (click)="loadErpReceipts()" [disabled]="erpReceiptsLoading">
						<mat-spinner *ngIf="erpReceiptsLoading" diameter="18"></mat-spinner>
						<mat-icon *ngIf="!erpReceiptsLoading">refresh</mat-icon>
						Refresh
					</button>
					<button mat-raised-button color="accent" (click)="syncErpReceipts()" [disabled]="erpSyncLoading || erpReceiptsLoading">
						<mat-spinner *ngIf="erpSyncLoading" diameter="18"></mat-spinner>
						<mat-icon *ngIf="!erpSyncLoading">sync</mat-icon>
						{{ erpSyncLoading ? 'Syncing…' : 'Sync receipts from PGS' }}
					</button>
					<span class="text-muted small ml-auto" *ngIf="erpReceiptsTotal > 0">
						Showing {{ erpReceipts.length }} of {{ erpReceiptsTotal }}
					</span>
				</div>
				<div *ngIf="erpReceiptsError" class="alert alert-warning py-2 small">{{ erpReceiptsError }}</div>
				<div *ngIf="erpReceiptsLoading && erpReceipts.length === 0" class="text-muted small">Loading…</div>
				<div *ngIf="!erpReceiptsLoading && erpReceipts.length === 0 && !erpReceiptsError" class="text-muted small">No inbound sends match these filters.</div>

				<table *ngIf="erpReceipts.length > 0" class="table table-sm table-hover">
					<thead>
						<tr>
							<th>PO#</th>
							<th>Type</th>
							<th>Send Status</th>
							<th class="text-end">Attempts</th>
							<th>Last Attempt</th>
							<th>Receipts</th>
							<th>PO Status</th>
							<th>Last Message / Error</th>
							<th></th>
						</tr>
					</thead>
					<ng-container *ngFor="let r of erpReceipts">
						<tr [class.table-active]="statusPanelPo === r.orderno">
							<td class="font-weight-bold">{{ r.orderno }}</td>
							<td class="text-nowrap small">
								<span *ngIf="r.order_source === 'rga'" class="badge badge-warning">RGA</span>
								<span *ngIf="r.order_source === 'credit'" class="badge badge-info">Credit</span>
								<span *ngIf="r.order_source === 'po' || !r.order_source" class="badge badge-secondary">PO</span>
							</td>
							<td>
								<span class="badge" [ngClass]="{
									'badge-success': r.last_status === 'success',
									'badge-danger': r.last_status === 'error',
									'badge-warning': r.last_status === 'warning'
								}">{{ r.last_status }}</span>
								<span *ngIf="r.error_count > 0" class="badge badge-light text-danger ml-1" matTooltip="Total errored attempts">{{ r.error_count }} err</span>
							</td>
							<td class="text-end small">{{ r.attempt_count }}</td>
							<td class="text-nowrap text-muted small">{{ r.last_attempt_at | date:'M/d/yy, h:mm a' }}</td>
							<td class="small">
								<span *ngIf="r.receipt_lines > 0" class="badge badge-info">{{ r.receipt_lines }} lines</span>
								<span *ngIf="r.qty_received_total" class="text-muted ml-1">qty {{ r.qty_received_total }}</span>
								<span *ngIf="!r.receipt_lines" class="text-muted">—</span>
							</td>
							<td>
								<span *ngIf="r.po_status" class="badge" [ngClass]="r.order_completed ? 'badge-success' : 'badge-secondary'">
									{{ r.po_status }}
								</span>
								<span *ngIf="!r.po_status" class="text-muted small">—</span>
							</td>
							<td class="small" [ngClass]="{'text-danger': r.last_status === 'error'}" style="max-width:28rem;word-break:break-word;">
								{{ r.last_message }}
								<div *ngIf="r.last_status !== 'error' && r.last_error_message" class="text-muted small mt-1">
									<em>Last error: {{ r.last_error_message }}</em>
								</div>
							</td>
							<td class="text-nowrap">
								<button mat-icon-button
									[color]="statusPanelPo === r.orderno ? 'accent' : ''"
									(click)="toggleStatusPanel(r.orderno)"
									matTooltip="Send history &amp; live status">
									<mat-icon>history</mat-icon>
								</button>
								<button *ngIf="r.last_status === 'error'" mat-stroked-button color="primary" class="btn-sm" (click)="openResendPreview(r.orderno)" matTooltip="Preview payload &amp; resend">
									<mat-icon>preview</mat-icon>
								</button>
							</td>
						</tr>
						<!-- Inline status + history panel -->
						<tr *ngIf="statusPanelPo === r.orderno">
							<td colspan="9" class="p-0">
								<div class="px-3 py-3" style="background:#f4f6fa;border-left:3px solid #1976d2">
									<div *ngIf="statusPanelLoading" class="text-muted small">Loading status…</div>
									<div *ngIf="statusPanelError" class="text-danger small">{{ statusPanelError }}</div>
									<ng-container *ngIf="!statusPanelLoading && !statusPanelError">
										<div class="d-flex align-items-center mb-2" style="gap:10px;flex-wrap:wrap">
											<strong class="small">PO {{ r.orderno }}</strong>
											<span *ngIf="statusPanelData" class="badge" [ngClass]="statusPanelData.sent ? 'badge-success' : 'badge-secondary'">
												{{ statusPanelData.sent ? 'Sent to 3PL' : 'Not sent' }}
											</span>
											<span *ngIf="statusPanelData?.attempt_count" class="text-muted small">{{ statusPanelData.attempt_count }} attempt(s)</span>
											<span *ngIf="statusPanelData?.pgsInboundID" class="text-muted small">PGS ID: {{ statusPanelData.pgsInboundID }}</span>
											<button mat-stroked-button color="accent" class="btn-sm ml-auto"
												(click)="submitFromPanel(r.orderno)"
												[disabled]="statusPanelSubmitLoading"
												matTooltip="Submit or resend this PO to 3PL">
												<mat-spinner *ngIf="statusPanelSubmitLoading" diameter="16"></mat-spinner>
												<mat-icon *ngIf="!statusPanelSubmitLoading">send</mat-icon>
												Submit / Resend
											</button>
										</div>
										<table *ngIf="statusPanelHistory.length > 0" class="table table-sm table-bordered mb-0" style="font-size:0.8rem">
											<thead>
												<tr>
													<th>When</th>
													<th>Status</th>
													<th>Message</th>
													<th>Raw</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let attempt of statusPanelHistory">
													<td class="text-nowrap text-muted">{{ attempt.created_at | date:'M/d/yy, h:mm a' }}</td>
													<td>
														<span class="badge" [ngClass]="{
															'badge-success': attempt.status === 'success',
															'badge-danger': attempt.status === 'error',
															'badge-secondary': attempt.status !== 'success' && attempt.status !== 'error'
														}">{{ attempt.status }}</span>
													</td>
													<td [ngClass]="{'text-danger': attempt.status === 'error'}">{{ attempt.message }}</td>
													<td>
														<button mat-icon-button (click)="openInboundAttemptRaw(attempt)" matTooltip="View raw request/response">
															<mat-icon style="font-size:16px">code</mat-icon>
														</button>
													</td>
												</tr>
											</tbody>
										</table>
										<div *ngIf="statusPanelHistory.length === 0 && statusPanelData" class="text-muted small">No send history yet.</div>
									</ng-container>
								</div>
							</td>
						</tr>
					</ng-container>
				</table>
			</div>
		</mat-tab>

		<!-- ── Tab 2: Receipt Lookup ── -->
		<mat-tab label="Receipt Lookup">
			<div class="tab-content">
				<p class="text-muted mb-3 small">Query raw receipt details from PGS by PO number.</p>
				<div class="d-flex align-items-center mb-3" style="gap:8px">
					<mat-form-field appearance="outline" class="tpl3pl-field mb-0">
						<mat-label>PO number</mat-label>
						<input matInput [(ngModel)]="receiptLookupPo" (keyup.enter)="lookupReceiptByPo()" placeholder="Enter PO">
					</mat-form-field>
					<button mat-raised-button color="primary" (click)="lookupReceiptByPo()" [disabled]="receiptLookupLoading">
						<mat-spinner *ngIf="receiptLookupLoading" diameter="20"></mat-spinner>
						<mat-icon *ngIf="!receiptLookupLoading">search</mat-icon>
						{{ receiptLookupLoading ? 'Loading…' : 'Look up' }}
					</button>
				</div>
				<div *ngIf="receiptError" class="alert alert-warning py-2 small">{{ receiptError }}</div>
				<div *ngIf="receiptData && receiptData.length > 0">
					<div *ngFor="let rec of receiptData" class="receipt-record mb-4">
						<div class="d-flex align-items-center mb-2" style="gap:8px">
							<strong>PO: {{ rec.orderNo ?? rec.orderno ?? '-' }}</strong>
							<span class="badge" [ngClass]="(rec.isClosed ?? rec.isclosed) ? 'badge-success' : 'badge-secondary'">
								{{ (rec.isClosed ?? rec.isclosed) ? 'Closed' : 'Open' }}
							</span>
						</div>
						<div *ngFor="let batch of (rec.Inbound_Items || rec.inbound_items || [])" class="pl-3 mb-3">
							<div class="text-muted small mb-1">Receipt {{ batch.receiptNo ?? batch.receiptno ?? '-' }} · {{ batch.receiptDate ?? batch.receiptdate ?? '-' }}</div>
							<table class="table table-sm table-bordered">
								<thead>
									<tr>
										<th>Line</th>
										<th>SKU</th>
										<th>Lot</th>
										<th class="text-end">Qty received</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let line of (batch.Inbound_Item || batch.inbound_item || [])">
										<td>{{ line.itemLine ?? line.itemline ?? '-' }}</td>
										<td>{{ line.sku ?? '-' }}</td>
										<td>{{ line.lotNumber ?? line.lotnumber ?? '-' }}</td>
										<td class="text-end">{{ line.qtyReceived ?? line.qtyreceived ?? '-' }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</mat-tab>

		<!-- ── Tab 4: Send Inbound ── -->
		<mat-tab label="Send Inbound">
			<div class="tab-content">
				<p class="text-muted mb-3 small">Send an inbound notification so the 3PL knows which PO and lines are expected.</p>
				<div class="tpl3pl-toolbar">
					<div class="tpl3pl-toolbar-filters">
						<mat-form-field appearance="outline" class="tpl3pl-field mr-2">
							<mat-label>PO number</mat-label>
							<input matInput [ngModel]="purchaseOrderNo" readonly placeholder="Get next PO">
							<button mat-icon-button matSuffix (click)="fetchNextPo()" [disabled]="poLoading" matTooltip="Get next PO">
								<mat-spinner *ngIf="poLoading" diameter="20"></mat-spinner>
								<mat-icon *ngIf="!poLoading">refresh</mat-icon>
							</button>
						</mat-form-field>
						<mat-form-field appearance="outline" class="tpl3pl-field mr-2">
							<mat-label>Order date</mat-label>
							<input matInput type="date" [(ngModel)]="orderDate">
						</mat-form-field>
						<mat-form-field appearance="outline" class="tpl3pl-field mr-2">
							<mat-label>Warehouse</mat-label>
							<input matInput [(ngModel)]="warehouse" placeholder="CM">
						</mat-form-field>
					</div>
					<div class="tpl3pl-toolbar-actions">
						<button mat-raised-button color="primary" (click)="openViewRawSend()">
							<mat-icon>visibility</mat-icon> View &amp; Send
						</button>
					</div>
				</div>

				<div class="row mb-3 mt-2">
					<div class="col-md-12 mb-2">
						<mat-slide-toggle [ngModel]="vendorIncludeInactive" (ngModelChange)="onVendorIncludeInactiveChange($event)">Include inactive vendors</mat-slide-toggle>
					</div>
					<div class="col-md-12">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Vendor</mat-label>
							<input matInput [ngModel]="vendorSearchInput" (ngModelChange)="onVendorSearchInput($event)" [matAutocomplete]="vendorAuto" placeholder="Type vendor ID or name">
							<mat-autocomplete #vendorAuto="matAutocomplete" [displayWith]="vendorDisplayFn" (optionSelected)="onVendorSelected($event.option.value)">
								<mat-option *ngFor="let v of vendorOptions" [value]="v">{{ v.supplierid }} - {{ v.suppname }}</mat-option>
							</mat-autocomplete>
						</mat-form-field>
					</div>
					<div class="col-md-8">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Address</mat-label>
							<input matInput [(ngModel)]="vendorAddress1" placeholder="Address line 1">
						</mat-form-field>
					</div>
					<div class="col-md-4">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Address 2</mat-label>
							<input matInput [(ngModel)]="vendorAddress2">
						</mat-form-field>
					</div>
					<div class="col-md-4">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>City</mat-label>
							<input matInput [(ngModel)]="vendorCity">
						</mat-form-field>
					</div>
					<div class="col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>State</mat-label>
							<input matInput [(ngModel)]="vendorState" placeholder="ST">
						</mat-form-field>
					</div>
					<div class="col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>ZIP</mat-label>
							<input matInput [(ngModel)]="vendorZipCode">
						</mat-form-field>
					</div>
					<div class="col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Country</mat-label>
							<input matInput [(ngModel)]="vendorCountry" placeholder="US">
						</mat-form-field>
					</div>
				</div>

				<div class="mb-2">
					<div class="d-flex align-items-center mb-2" style="gap:8px">
						<h6 class="mb-0">Line items</h6>
						<mat-form-field appearance="outline" class="tpl3pl-field mb-0">
							<mat-label>Default qty</mat-label>
							<input matInput type="number" min="1" [(ngModel)]="defaultQtyForLoad" (ngModelChange)="onDefaultQtyChange()">
						</mat-form-field>
						<mat-form-field appearance="outline" class="tpl3pl-field mb-0">
							<mat-label>Filter SKU</mat-label>
							<input matInput [(ngModel)]="skuLoadSearch">
						</mat-form-field>
						<button mat-stroked-button (click)="loadSkusFromInventoryScope()" [disabled]="loadSkusLoading">
							<mat-spinner *ngIf="loadSkusLoading" diameter="18"></mat-spinner>
							<mat-icon *ngIf="!loadSkusLoading">inventory</mat-icon>
							{{ loadSkusLoading ? 'Loading…' : 'Load from scope' }}
						</button>
					</div>
					<table class="table table-sm table-bordered">
						<thead>
							<tr>
								<th>SKU</th>
								<th>Qty</th>
								<th>Description</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let line of lines; let i = index">
								<td><input class="form-control form-control-sm" [(ngModel)]="line.itemNumber" placeholder="SKU" name="item_{{i}}"></td>
								<td><input type="number" min="1" class="form-control form-control-sm" [(ngModel)]="line.qtyOrdered" name="qty_{{i}}"></td>
								<td><input class="form-control form-control-sm" [(ngModel)]="line.itemDescription" placeholder="Required" name="desc_{{i}}"></td>
								<td><button mat-icon-button (click)="removeLine(i)" [disabled]="lines.length <= 1"><mat-icon>remove_circle_outline</mat-icon></button></td>
							</tr>
						</tbody>
					</table>
					<button mat-stroked-button (click)="addLine()"><mat-icon>add</mat-icon> Add line</button>
				</div>
			</div>
		</mat-tab>

	</mat-tab-group>
</div>
